export default {"src":"/_next/static/media/location_visits_2.5d3532e8.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};